(() => {
  const select = document.getElementById('ShippingPrefecture');
  const result = document.getElementById('ShippingDateText');

  if (!select || !result) return;

  const blackoutDates = new Set(window.shippingDateConfig?.blackoutDates ?? []);

  const pad = (num) => String(num).padStart(2, '0');

  const addDays = (date, days) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate;
  };

  const formatDateKey = (date) => {
    return [date.getFullYear(), pad(date.getMonth() + 1), pad(date.getDate())].join('-');
  };

  const formatShortDate = (date) => {
    return `${date.getMonth() + 1}/${date.getDate()}`;
  };

  const formatDeliveryDate = (date) => {
    const weekdays = ['日', '月', '火', '水', '木', '金', '土'];

    return `${date.getMonth() + 1}/${date.getDate()}(${weekdays[date.getDay()]})`;
  };

  const getNextShippableDate = (date) => {
    let shippingDate = new Date(date);

    while (blackoutDates.has(formatDateKey(shippingDate))) {
      shippingDate = addDays(shippingDate, 1);
    }

    return shippingDate;
  };

  const getSchedule = () => {
    const deliveryLeadtime = Number(select.value);

    if (!deliveryLeadtime) return null;

    const now = new Date();

    // 12時まで→今日、12時以降→翌日
    const shippingStartOffset = now.getHours() >= 12 ? 1 : 0;

    const firstShippingCandidate = addDays(now, shippingStartOffset);

    // 出荷不可日を回避
    const shippingDate = getNextShippableDate(firstShippingCandidate);

    // お届け日
    const deliveryDate = addDays(shippingDate, deliveryLeadtime);

    return {
      shippingDate,
      deliveryDate,
    };
  };

  const updateShippingDate = () => {
    const schedule = getSchedule();

    if (!schedule) {
      result.textContent = '';
      return;
    }

    const todayKey = formatDateKey(new Date());
    const shippingKey = formatDateKey(schedule.shippingDate);
    const orderLabel = todayKey === shippingKey ? '本日' : formatShortDate(schedule.shippingDate);

    result.textContent = `${orderLabel} 12:00までの注文で、最短${formatDeliveryDate(schedule.deliveryDate)}頃お届け予定`;
  };

  select.addEventListener('change', updateShippingDate);

  if (select.value) {
    updateShippingDate();
  }
})();
